import React from 'react'
import { InputFile } from './common'

export default class ChatEditor extends React.Component {
	constructor(props) {
		super(props);
		this.state = {file: null, dragging: false};
		this.editor = React.createRef();
		this.onAddFile = this.onAddFile.bind(this);
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		const model = nextProps.model || {};
		const file = model.file || null;

		if (file === prevState.file) {
			return null;
		}
		return {
			file: file
		};
	}

	componentDidMount() {
		const editor = this.editor.current;

		editor.addEventListener("input", e => {
			this.props.model[this.props.name] = editor.innerText;
			if (this.props.onInput) {
				this.props.onInput(e);
			}
			this.forceUpdate();
		})
		editor.addEventListener("keydown", e => {
			if (e.ctrlKey || e.shiftKey) {
				return;
			}
			switch(e.keyCode) {
				case 13: // enter
					e.preventDefault();
					this.onSend();
					break;
				case 38: // seta cima
					if (this.props.onSelect && !this.props.model[this.props.name]) {
						this.props.onSelect();
					}
					break;
				case 27: // escape
				if (this.props.onSelect && this.props.model[this.props.name]) {
					this.props.onSelect(true);
				}
			}
		})
		editor.addEventListener("paste", e => {
			return this.onDropFile(e, e.clipboardData);
		})
//		editor.addEventListener("dragover", e => {
//			e.preventDefault();
//		})
		editor.addEventListener("dragenter", e => {
			console.log("enter");
			this.setState({dragging: true});
		})
		editor.addEventListener( "dragleave", e => this.setState({dragging: false}) )
		editor.addEventListener( "dragend", e => this.setState({dragging: false}) )
		editor.addEventListener("drop", e => {
			return this.onDropFile(e, e.dataTransfer);
		})
		editor.focus()
	}

	onDropFile(ev, data) {
		if (data instanceof DataTransfer && data.files.length > 0) {
			ev.preventDefault()
			this.props.model['file'] = data.files[0]
			this.setState({file: data.files[0], dragging: false})
			return false
		}
		return true
	}

	componentDidUpdate() {
		const editor = this.editor.current;
		const {model, name} = this.props;

		if (document.activeElement !== editor || editor.innerText != model[name]) {
			editor.innerText = model[name];
		}
	}

	getQuote(msg, chat) {
		if (!msg.quote_id || !chat || !chat.hasOwnProperty(msg.quote_id)) {
			return null
		}
		const msg_quote = chat[msg.quote_id]
		return (
			<div className="chat-quote chat-quote-reply">
				{msg_quote.comment}
				<span className="pull-right pointer" onClick={this.props.onClearQuote || null}>
					<em className="la la-close" />
				</span>
			</div>
		)
	}

	onSend() {
		const {file} = this.state
		if (this.props.canSend === false || (!this.props.model[this.props.name] && !file)) {
			return;
		}
		this.props.model[this.props.name] = this.props.model[this.props.name].trim();
		this.props.model['file'] = file || null;
		if (this.props.model[this.props.name] || file) {
			this.props.onSend();
		}
	}

	onAddFile(e) {
		this.props.model['file'] = e ? e.currentTarget.files[0] : null;
		this.setState({file: this.props.model['file']})
	}

	render() {
		const {model, name, data} = this.props
		const{file, dragging} = this.state
		const uploader = <InputFile
			type="file"
			label={null}
			title={!file ? __('attrs_upload_file') : null}
			file={file}
			onChange={this.onAddFile}
		/>
		const quote = this.getQuote(model, data)

		return (
			<div>
				{file ? uploader : null}
				{quote}
				<div className={classNames("d-flex chat-editor", dragging ? 'dragging' : null)}>
					{!file
						? uploader
						: <span className="label">
							<button className="btn btn-circular" onClick={this.props.onCancel}>
								<em className="la la-undo" />
							</button>
						  </span>
					}
					<span
						role="textbox"
						ref={this.editor}
						className="textarea"
						contentEditable={true}
						suppressContentEditableWarning={true}
					/>
					<button
						className={classNames("btn btn-circular", model[name] == '' || this.props.canSend === false ? 'btn-default' : 'btn-primary')}
						title={__('socials_chat_send_title')}
						onClick={this.onSend.bind(this)}
					>
						<em className="la la-paper-plane" />
					</button>
				</div>
			</div>
		);
	}
}
